import React, { type FC } from "react";

interface IncludeInverseKinematicsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  labelTextClassName?: string;
}

export const IncludeInverseKinematicsCheckbox: FC<
  IncludeInverseKinematicsCheckboxProps
> = ({
  checked,
  onChange,
  disabled = false,
  className = "flex items-center gap-2 w-fit cursor-pointer select-none transition-opacity duration-200",
  labelTextClassName = "text-[#b6b2b2] text-[13px] font-['Inter:Medium',sans-serif] font-medium",
}) => {
  return (
    <label
      data-testid="reboot-live-include-ik-label"
      className={`${className} group ${disabled ? "opacity-40 pointer-events-none" : ""}`}
    >
      <input
        type="checkbox"
        data-testid="reboot-live-include-ik-checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        className="peer sr-only"
      />
      <div
        aria-hidden="true"
        className="w-4 h-4 rounded-[3px] border flex items-center justify-center transition-all shrink-0 bg-transparent border-[rgba(255,255,255,0.25)] group-hover:border-[rgba(255,255,255,0.5)] peer-checked:bg-[#fb6a07] peer-checked:border-[#fb6a07] peer-focus-visible:ring-2 peer-focus-visible:ring-[#fb6a07] peer-focus-visible:ring-offset-0"
      >
        {checked && (
          <svg className="w-2.5 h-2.5" viewBox="0 0 10 10" fill="none">
            <path
              d="M1.5 5L4 7.5L8.5 2.5"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <span className={labelTextClassName}>Include time series data</span>
    </label>
  );
};
